module.exports = __webpack_public_path__ + "img/photo-lifestyle-props.fd400aba.png";